export enum Type {
  FUNCTIONALITY = 'functionality',
  DEVICE_MODEL = 'device_model',
  PROTOCOL = 'protocol'
}
